<template>
    <div>
        <div class="unitpricewrp" v-if="this.showPricePerTimeUnit" :class="{faded: ajax}">
            <span class="unitprice" :class="{faded: ajax || !isValid}">
                {{ lang.only }} {{timeUnitPriceText}}
            </span>
        </div>

        <div class="totalpricewrp" :class="{faded: ajax || !isValid}" :style="{'--priceColor':featureFlags.price_background}">
            <span class="cheapestPrice" v-if="disableButton" :style="{'--priceTextColor':featureFlags.price_text_color}">ab</span>
            <span class="totalprice notranslate" :style="{'--priceTextColor':featureFlags.price_text_color}">
                {{currencyFormatter.format(finalPrice)}}
                <div id="product-configurator-spinner"></div>
            </span>

            <span v-if="showSinglePayment" class="totalpriceinfo" :style="{'--priceTextColor':featureFlags.price_text_color}">
                {{ lang.single_payment }}
            </span>

            <span v-if="showMonthlyPayment" class="totalpriceinfo" :style="{'--priceTextColor':featureFlags.price_text_color}">
                {{ lang.monthly_payment }}
            </span>

            <span v-if="showYearlyPayment" class="totalpriceinfo" :style="{'--priceTextColor':featureFlags.price_text_color}">
                {{ lang.yearly_payment }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: "totalPrice",
    props: ['lang', 'configContractType', 'configDuration', 'ajax', 'isValid','featureFlags', 'disableButton'],
    data: function () {
        return {
            currencyFormatter: new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}),
            sumFinalPrice: 0,
        };
    },
    computed: {
        showPricePerTimeUnit: function () {
            return this.$parent.product.pricePerTimeUnit !== 'none';
        },

        timeUnitPriceText: function () {
            if (this.$parent.product.pricePerTimeUnit === 'daily') {
                return this.currencyFormatter.format(this.$store.state.current.pricing.dailyPrice || 0) + ' pro Tag';
            } else if (this.$parent.product.pricePerTimeUnit === 'monthly') {
                return this.currencyFormatter.format(this.$store.state.current.pricing.monthlyPrice || 0) + ' pro Monat';
            }
        },

        currentContractType: function () {
            return this.$store.state.current.contractType;
        },

        currentDurationValue: function () {
            return this.$store.state.current.durationValue;
        },

        currentDurationValueTimeUnit: function () {
            return this.$store.state.current.durationValue.duration.timeUnit;
        },

        finalPrice: function () {
            return this.$store.state.bundlePrice > 0
                   ? this.$store.state.current.pricing.price + this.$store.state.bundlePrice
                   : this.$store.state.current.pricing.price;
        },

        showSinglePayment: function () {
            return this.currentContractType === this.configContractType.single;
        },

        showMonthlyPayment: function () {
            return this.currentContractType === this.configContractType.recurring
                && this.currentDurationValue
                && this.currentDurationValueTimeUnit === this.configDuration.month;
        },

        showYearlyPayment: function () {
            return this.currentContractType === this.configContractType.recurring
                && this.currentDurationValue
                && this.currentDurationValueTimeUnit === this.configDuration.year
        }
    }
}
</script>

<style scoped>

</style>
